export const environment = {
  production: true,
  host: '/'
};

